import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Moon, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const KEY = "dismissed-missing-payments";
const istDay = (offset = 0) => { const d = new Date(Date.now() + offset * 86400000); return d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" }); };
const norm = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, " ");

export const MissingPayments = () => {
  const nav = useNavigate();
  const { user, isAdmin } = useAuth();
  const [gone, setGone] = useState(() => JSON.parse(localStorage.getItem(KEY) || "[]"));
  const { data = [] } = useQuery({ queryKey: ["receipts"], queryFn: () => api.get("/receipts").then((r) => r.data) });
  const yday = istDay(-1);
  const list = data.filter((r) => r.inputs?.spot && r.inputs.enquiryDate === yday && !r.form_fee && !["admitted", "partial"].includes(r.status)
    && (isAdmin || norm(r.inputs.counselorName) === norm(user?.name)) && !gone.includes(r.id));
  if (!list.length) return null;
  const dismiss = (id) => { const next = [...gone.slice(-200), id]; localStorage.setItem(KEY, JSON.stringify(next)); setGone(next); };
  return (
    <div className="no-print fade-up mb-4 rounded-lg border border-sky-200 bg-sky-50/70 p-4" data-testid="missing-payments-banner">
      <div className="mb-1 flex items-center gap-2 text-sm font-bold text-sky-900"><Moon className="h-4 w-4" />Record last evening's payments ({list.length})</div>
      <p className="mb-2 text-xs text-sky-900/80">These Spot enquiries from yesterday have no form fee yet. If the parent paid late in the evening, record it with yesterday's date and a short reason to keep Spot.</p>
      <ul className="flex flex-wrap gap-2">
        {list.map((r) => (
          <li key={r.id} className="flex items-center rounded-full border border-sky-300 bg-white text-xs" data-testid={`missing-payment-${r.receipt_no}`}>
            <button onClick={() => nav(`/?edit=${r.id}`)} className="rounded-l-full px-3 py-1.5 font-medium text-plum-950 transition-colors duration-150 hover:bg-sky-100" data-testid={`missing-payment-open-${r.receipt_no}`}>
              {r.inputs.childName || r.receipt_no} <span className="font-num text-slate-500">· {r.receipt_no}</span>
            </button>
            <button onClick={() => dismiss(r.id)} title="Dismiss" className="rounded-r-full border-l border-sky-200 px-2 py-1.5 text-slate-400 transition-colors duration-150 hover:text-slate-700" data-testid={`missing-payment-dismiss-${r.receipt_no}`}>
              <X className="h-3.5 w-3.5" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
